export enum QueueType {
  TheatreUpdateQueue = 1,
  TheatreVisitSubmitQueue = 2,
  TheatreStopTimerAndScanOutQueue = 3,
  TheatreStopTimerAndMoveToRecoveryQueue = 4,
  UpdateToProcedureInProgress = 5,
  UpdateToProcedureComplete = 6,
  TheatreStartTimerAndMoveToOperatingRoomQueue = 7,
  CompleteDeferredTheatreVisitQueue = 8,
  NoStockFoundForMaterialQueue = 9,
  PatientNoteCreatedQueue = 10,
  ChecklistAnsweredQuestionsQueue = 11
}